import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import ProfileAvatar from "../../../../../components/ui/ProfileAvatar";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import Button from "../../../../../components/ui/Button";
import RadioButton from "../../../../../components/ui/RadioButton";
import DropDown from "../../../../../components/ui/DropDown";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import IPInformation from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/IPAddress/IPInformation";
import SubDomains from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/IPAddress/SubDomains";
import PortInformation from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/IPAddress/PortInformation";
import SSLCertificate from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/IPAddress/SSLCertificate";

import { filterIcon, searchIcon } from "../../../../../utils/icons";
import { formatNumber, getHostingProviderImageUrl } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getIPAddressList, getScanInfoStats, resetScanInfoStats, resetIpAddressList } from "../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../apiEndpoints";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const IpAddress = () => {

    const ipAddressListResponse = useSelector((state) => state.scanInfo?.ipAddressList);
    const ipAddressStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);

    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const [activeTab, setActiveTab] = useState("ipInformation");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedIpAddress, setSelectedIpAddress] = useState("");
    const [scanNotFound, setScanNotFound] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [ipAddressStats, setIpAddressStats] = useState("");
    const [showViewAllModal, setShowViewAllModal] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const [ipAddressLists, setIpAddressLists] = useState(null);

    const [ipAddressSearch, setIpAddressSearch] = useState("");
    const [updatedIpAddressSearchValue, setUpdatedIpAddressSearchValue] = useState("");

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedRiskyPortType, setSelectedRiskyPortType] = useState("");
    const [selectedBlacklisted, setSelectedBlacklisted] = useState("");
    const [selectedCompromised, setSelectedCompromised] = useState("");
    const [selectedHostingProviders, setSelectedHostingProviders] = useState("");
    const [hostingProviderListOption, setHostingProviderListOption] = useState([]);

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});
    
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setContextCurrentPage(newPage)
        setTriggerListFetch(true);
    };

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType,
            riskyPort: selectedRiskyPortType,
            blacklisted: selectedBlacklisted,
            compromised: selectedCompromised,
            hostingProviderType: selectedHostingProviders
        }
        setSelectedFilterValue(obj);
        setContextCurrentPage(1)
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1); 
        setSelectedFilterValue({});
        setNewFindingsType("");
        setSelectedRiskyPortType("");
        setSelectedBlacklisted("");
        setSelectedCompromised("");
        setSelectedHostingProviders("");
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const fetchIPAddressStats = useCallback(() => {
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.ipAddress.ipAddressStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getScanInfoStats(url));
    },[dispatch, domainId, scanId, organizationId])

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedIpAddressSearchValue(searchTerm)
    }, 500), []);

    const fetchIpAddressList = useCallback(()=> {
        const baseUrl = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&page=${currentPage}&page_size=10&organization_id=${organizationId}` : `&page=${currentPage}&page_size=10&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedIpAddressSearchValue ? `&query=${updatedIpAddressSearchValue}` : "";
        const hostingProvider = selectedFilterValue.hostingProviderType ? `&hosting_provider=${selectedFilterValue.hostingProviderType}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const riskyPort = selectedFilterValue.riskyPort && selectedFilterValue.riskyPort !== "all" ? `&risky_port=${selectedFilterValue.riskyPort === "yes" ? true : false}` : "";
        const blacklisted = selectedFilterValue.blacklisted && selectedFilterValue.blacklisted !== "all" ? `&blacklisted=${selectedFilterValue.blacklisted === "yes" ? true : false}` : "";
        const compromised = selectedFilterValue.compromised && selectedFilterValue.compromised !== "all" ? `&compromised=${selectedFilterValue.compromised === "yes" ? true : false}` : "";        
        const url = `${baseUrl}${queryParams}${hostingProvider}${newFindings}${riskyPort}${blacklisted}${compromised}`
        setIsLoading(true);
        setScanNotFound(false)
        dispatch(getIPAddressList(url))
    },[dispatch, domainId, scanId, organizationId, currentPage, updatedIpAddressSearchValue, selectedFilterValue])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        
        }
    },[showFilter])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchIPAddressStats();
            setCurrentPage(1)
            setContextCurrentPage(1)
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchIPAddressStats]);

    useEffect(() => {
        if (triggerListFetch) {
            fetchIpAddressList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchIpAddressList]);

    useEffect(() => {
        setCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedIpAddressSearchValue]);

    useEffect(()=>{
        if(ipAddressListResponse !== null) {
            setIpAddressLists(ipAddressListResponse)
            if(ipAddressListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(ipAddressListResponse?.results?.length > 0) {                
                setSelectedIpAddress(ipAddressListResponse?.results[0])
            }
            dispatch(resetIpAddressList())
            setIsLoading(false);
        }
    },[ipAddressListResponse, dispatch])

    useEffect(()=>{
        if(ipAddressStatsResponse !== null) {
            setStatsLoading(false)
            setIpAddressStats(ipAddressStatsResponse)
            if(ipAddressStatsResponse?.hosting_provider_type?.records && Object.entries(ipAddressStatsResponse?.hosting_provider_type?.records).length > 0) {
                let list = Object.entries(ipAddressStatsResponse?.hosting_provider_type?.records).map(([key]) => {
                    return {
                        label: key,
                        value: key
                    }
                })
                setHostingProviderListOption(list)
            } else {
                setHostingProviderListOption([])
            }
            dispatch(resetScanInfoStats())
        }
    },[ipAddressStatsResponse, dispatch])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"ipaddress"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">IP Addresses</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(ipAddressStats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(ipAddressStats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(ipAddressStats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>                                                
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"ipaddress"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page ports-container rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Ports</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(ipAddressStats?.port_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Ports</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(ipAddressStats?.port_type?.risky_port)}</span> Risky</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(ipAddressStats?.port_type?.non_risky_port)}</span> Non Risky</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"ipaddress"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="sub-domain-type-container web-server-type-container rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Hosting Providers</p>
                                            {ipAddressStats !== "" && ipAddressStats?.hosting_provider_type?.records && Object.entries(ipAddressStats?.hosting_provider_type?.records).length > 4 && <p className="view-all" onClick={()=>{setShowViewAllModal(true)}}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(ipAddressStats?.hosting_provider_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <div className="sub-domain-content">
                                            <Row className="mt-3">
                                                {
                                                    ipAddressStats !== "" && ipAddressStats?.hosting_provider_type?.records && Object.entries(ipAddressStats?.hosting_provider_type?.records).length > 0 &&
                                                    Object.entries(ipAddressStats?.hosting_provider_type?.records).map(([key, value], index) => {
                                                        if(index <= 3) {
                                                            return (
                                                                <Col lg={6} key={`hosting-${index}`} className="mb-3">
                                                                    <div className="d-flex align-items-center w-100 gap-2">
                                                                        <p className="count-type">{formatNumber(value)}</p>
                                                                        <ProfileAvatar type="domain" name={key} imageUrl={getHostingProviderImageUrl(key)} />
                                                                    </div>
                                                                </Col>
                                                            )
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={3}>
                            <div className="bg-white-with-shadow subdomain-list-container h-100">
                                <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                    <h1>IP Address List</h1>
                                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                    <div className="position-relative">
                                        <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                            <h6>New Findings</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={`new-${index}`} isChecked={data.value === newFindingsType} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>Risky Port</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={`risky-port-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedRiskyPortType(value)}} key={`risky-${index}`} isChecked={data.value === selectedRiskyPortType} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>Blacklisted</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={`blacklisted-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedBlacklisted(value)}} key={`black-${index}`} isChecked={data.value === selectedBlacklisted} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>Compromised</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={`compromised-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedCompromised(value)}} key={`compare-${index}`} isChecked={data.value === selectedCompromised} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>Hosting Providers</h6>
                                            <DropDown 
                                                placeHolder={"Hosting Providers"}
                                                options={hostingProviderListOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedHostingProviders(data.value)}}
                                                defaultSelectedValue={selectedHostingProviders}
                                            />
                                            <div className="filter-apply-btn mt-3">
                                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                                <div className="search-container px-3 position-relative">
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                    <input type="text" 
                                        placeholder="Search" 
                                        className="w-100 rounded input" 
                                        value={ipAddressSearch}
                                        onChange={(e)=>{                                            
                                            setIpAddressSearch(e.target.value)
                                            requestSearch(e.target.value)
                                            setCurrentPage(1)
                                        }}
                                    />
                                </div>
                                <div className="list-main-container">
                                    { !isLoading && scanNotFound &&
                                        <NoDataFound noDataText={ipAddressLists?.description}/>
                                    }
                                    {
                                        isLoading && !scanNotFound ?
                                        <SkeletonLoader type={"line"} count={5} currentPage={"ipAddress"} />
                                        :
                                        (
                                            ipAddressLists?.results?.length > 0 &&
                                            ipAddressLists?.results.map((data, index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className={`sub-domain-list py-2 px-3 ${selectedIpAddress !== "" && selectedIpAddress?.id === data?.id ? "active" : ""}`} onClick={()=>{setSelectedIpAddress(data)}}>
                                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                                <p className="sub-domain-heading">{data?.ip_address}</p>
                                                                {data.new_record && <span className="new-subdomain">New</span>}
                                                            </div>                                                    
                                                            <p className="sub-domain-name">{data.domain}</p>
                                                            {data?.risky_port?.is_risky_port && <span className="subdomain-status blacklisted">Risky Port</span>}
                                                            {data?.compromised?.is_compromised && <span className="subdomain-status blacklisted">Compromised</span>}
                                                            {data?.malware?.is_malware && <span className="subdomain-status blacklisted">Infected</span>}
                                                            {data?.blacklisted?.is_blacklisted && 
                                                                    <span className="subdomain-status blacklisted">Blacklisted</span>
                                                                    
                                                            }                                                        
                                                        </div>
                                                    </motion.div>
                                                )
                                            })
                                        )
                                    }
                                    { !isLoading && ipAddressLists?.results?.length > 0 &&
                                        <PaginationArrow 
                                            totalCount={ipAddressLists?.meta?.total_results}
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                        />                                  
                                    }
                                    { !isLoading && ipAddressLists?.results?.length === 0 &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"IP Address Not Found"}/>
                                        </motion.div>
                                        
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="tab-container d-flex rounded">
                                    <p className={`rounded text-center ${activeTab === "ipInformation" ? "active" : ""}`} onClick={()=>{setActiveTab('ipInformation')}}>IP Information</p>
                                    <p className={`rounded text-center ${activeTab === "subdomains" ? "active" : ""}`} onClick={()=>{setActiveTab('subdomains')}}>Subdomains</p>
                                    <p className={`rounded text-center ${activeTab === "portInformation" ? "active" : ""}`} onClick={()=>{setActiveTab('portInformation')}}>Port Information</p>
                                    <p className={`rounded text-center ${activeTab === "SSlCertificate" ? "active" : ""}`} onClick={()=>{setActiveTab('SSlCertificate')}}>SSL Certificate</p>
                                </div>
                                <div className="tab-details-content mt-3">
                                    { !isLoading && scanNotFound ?
                                        <NoDataFound noDataText={ipAddressLists?.description}/>
                                        :
                                        ( !isLoading && ipAddressLists?.results?.length === 0 ?
                                            <NoDataFound noDataText={"No Data Found"}/>
                                            :
                                            <>
                                                {activeTab === "ipInformation" && <IPInformation selectedIpDetails={selectedIpAddress} isLoading={isLoading} />}
                                                {activeTab === "subdomains" && <SubDomains selectedIpDetails={selectedIpAddress} domainId={domainId} scanId={scanId}/>}
                                                {activeTab === "portInformation" && <PortInformation selectedIpDetails={selectedIpAddress} domainId={domainId} scanId={scanId}/>}
                                                {activeTab === "SSlCertificate" && <SSLCertificate sslData={selectedIpAddress} domainId={domainId} scanId={scanId} currentPageType={"ipAddress"}/>}
                                            </>
                                        )
                                    }                                    
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Modal
                        show={showViewAllModal}
                        onHide={()=>setShowViewAllModal(false)}
                        size="md"
                        centered
                        className=""
                        >
                            <Modal.Body>
                                <div className="delete-organization-container">
                                    <h4>Hosting Providers</h4>
                                    <div className="p-2 m-2 type-list-container">
                                        <div className="mt-3">
                                            {
                                                ipAddressStats !== "" && ipAddressStats?.hosting_provider_type?.records && Object.entries(ipAddressStats?.hosting_provider_type?.records).length > 0 &&
                                                Object.entries(ipAddressStats?.hosting_provider_type?.records).map(([key, value], index) => {
                                                    return (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                                        >
                                                            <div>
                                                                <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">                                                                
                                                                    <ProfileAvatar type="domain" name={key} imageUrl={getHostingProviderImageUrl(key)} />
                                                                    <p className="count-type total-count">{formatNumber(value)}</p>
                                                                </div>
                                                            </div>
                                                        </motion.div>                                                        
                                                    )                                         
                                                })
                                            }
                                        </div> 
                                    </div>
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <div className="w-50">
                                            <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                    </Modal>
                </div>
            </div>
        </>
        
    )
}


export default IpAddress;